<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        label="Username"
        v-model="searchData.username"
        type="text"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData('username')"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        label="Fullname"
        v-model="searchData.fullname"
        type="text"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData('fullname')"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        label="Role"
        v-model="searchData.role"
        :items="itemsRole"
        item-text="role"
        item-value="role"
        @change="getData"
        clearable
        hide-details="true"
        dense
        @input="searchData.role = $event ? $event : ''"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-menu
        ref="dateMenu"
        v-model="dateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            label="Created At"
            v-model="dateFormatted"
            v-bind="attrs"
            @blur="searchData.created_at = parseDate(dateFormatted)"
            v-on="on"
            hide-details="true"
            dense
            clearable
            @click:clear="clearFilterData('created_at')"
          />
        </template>
        <v-date-picker
          v-model="searchData.created_at"
          no-title
          scrollable
          @input="dateMenu = false"
        >
          <v-spacer />
          <v-btn text color="primary" @click="dateMenu = false"> Cancel </v-btn>
        </v-date-picker>
      </v-menu>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-menu
        ref="dateMenuLastLogin"
        v-model="dateMenuLastLogin"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            label="Last Login"
            v-model="dateFormattedLastLogin"
            v-bind="attrs"
            @blur="searchData.last_login_at = parseDate(dateFormattedLastLogin)"
            v-on="on"
            hide-details="true"
            dense
            clearable
            @click:clear="clearFilterData('last_login_at')"
          />
        </template>
        <v-date-picker
          v-model="searchData.last_login_at"
          no-title
          scrollable
          @input="dateMenuLastLogin = false"
        >
          <v-spacer />
          <v-btn text color="primary" @click="dateMenuLastLogin = false">
            Cancel
          </v-btn>
        </v-date-picker>
      </v-menu>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        label="Status"
        v-model="searchData.status"
        :items="listStatusUser"
        item-text="text"
        item-value="value"
        @change="getData"
        @input="searchData.status = $event ? $event : ''"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import { dataListStatusUser } from '../../../../store/params';
import { date, formatDate, parseDate } from '../../../../lib/helpers';

export default {
  props: ['search', 'options'],
  data: () => ({
    listStatusUser: dataListStatusUser,
    dateFormatted: '',
    dateFormattedLastLogin: '',
    dateMenu: false,
    dateMenuLastLogin: false,
  }),

  async mounted() {
    this.getRoles();
  },
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    itemsRole() {
      return this.$store.state.rbac.role.allActiveRole;
    },
  },
  watch: {
    'searchData.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.searchData.created_at);
        this.getData();
      },
    },

    'searchData.last_login_at': {
      handler() {
        this.dateFormattedLastLogin = this.formatDate(
          this.searchData.last_login_at
        );
        this.getData();
      },
    },
  },
  beforeDestroy() {
    this.resetFilters();
  },
  methods: {
    resetFilters() {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = '';
      });
      this.getData();
    },
    clearFilterData(field) {
      this.searchData[field] = ''; 
      this.getData(); 
    },
    formatDate,
    parseDate,
    getRoles() {
      this.$store.dispatch('rbac/role/fetchActiveRoles', {
        date,
      });
    },

    getData() {
      const newOptions = { ...this.options, page: 1 };
      this.$emit('update:options', newOptions);
      this.$emit('getDataParent');
    },
  },
};
</script>
